package tech.gensert.portal.web.routes

import react.router.useLocation

fun useShowcaseIdParam(): String =
    useLocation().pathname.substringAfterLast("/")
